import { useEffect } from 'react';

interface UseHandleOnOpenptions {
  isOpen: boolean;
}

export function useHandleOnOpen(options: UseHandleOnOpenptions) {
  const { isOpen } = options;

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';

      return () => {
        document.body.style.overflow = '';
      };
    }
  }, [isOpen]);
}
